import { Button as ChakraButton } from '@chakra-ui/react'

/**
 * Button Component
 * Wrapper around Chakra UI Button with consistent styling
 */
export function Button({
  children,
  variant = 'solid',
  size = 'md',
  ref,
  bg,
  color,
  colorScheme,
  _hover,
  _active,
  _disabled,
  ...props
}) {
  // Default padding based on size
  const defaultPadding = {
    sm: { px: 3, py: 1.5 },
    md: { px: 4, py: 2 },
    lg: { px: 5, py: 2.5 },
  }

  const padding = defaultPadding[size] || defaultPadding.md

  // primary blue colors for solid variant (only if no custom bg or colorScheme)
  const shouldApplyPrimaryColors = variant === 'solid' && !bg && !colorScheme

  return (
    <ChakraButton
      ref={ ref }
      variant={ variant }
      size={ size }
      bg={ shouldApplyPrimaryColors ? '#0052CC' : bg }
      color={ shouldApplyPrimaryColors ? 'white' : color }
      colorScheme={ colorScheme }
      _hover={ shouldApplyPrimaryColors ? { bg: '#0747A6' } : _hover }
      _active={ shouldApplyPrimaryColors ? { bg: '#0747A6' } : _active }
      _disabled={ shouldApplyPrimaryColors ? {
        bg: '#EBECF0',
        color: '#8993A4',
        cursor: 'not-allowed',
        opacity: 1,
      } : _disabled }
      { ...padding }
      fontWeight="500"
      borderRadius="3px"
      transition="all 0.1s"
      { ...props }
    >
      { children }
    </ChakraButton>
  )
}

export default Button
